import React, { useEffect, useState, useReducer } from "react";
// import { connect } from "react-redux";
import { Link, NavLink, withRouter } from "react-router-dom";

import {
    Grid,
    Paper,
    Typography,
    Avatar,
    Badge,
    IconButton,
    Card,
    Button,
    Divider,
    TextField,
    ButtonBase,
    Snackbar,
    Chip,
} from "@material-ui/core";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import { makeStyles } from "@material-ui/core/styles";
import ReadMoreReact from "read-more-react";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
// import "./Styles.css";
// import { SVGIcon } from 'react-md';
// import { Avatar } from 'react-md';

// import redo from 'icons/redo.svg';

// import { makeStyles } from '@material-ui/core/styles';
import clsx from "clsx";
// import Card from '@material-ui/core/Card';
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
// import Avatar from '@material-ui/core/Avatar';
// import IconButton from '@material-ui/core/IconButton';
// import Typography from '@material-ui/core/Typography';
import { red } from "@material-ui/core/colors";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
// import MoreVertIcon from '@material-ui/icons/MoreVert';
// import Avatar from 'react-avatar';
// import CommentForm from "./CommentForm";
// import WebFont from "webfontloader";
// import CommentFeed from "./CommentFeed";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Moment from "react-moment";
import ShowMoreText from "react-show-more-text";
// import VerifiedLogo from "../../../svg/Verified.svg";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import FiberManualRecordRoundedIcon from "@material-ui/icons/FiberManualRecordRounded";
import { CopyToClipboard } from "react-copy-to-clipboard";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import MuiAlert from "@material-ui/lab/Alert";
import QuestionAnswerRoundedIcon from "@material-ui/icons/QuestionAnswerRounded";
// import { addCommentNew } from "../../../actions/diaryActions";
import ReactTimeAgo from "react-time-ago";
import { useDoubleTap } from "use-double-tap";
import { positions } from "@material-ui/system";
import FaceIcon from "@material-ui/icons/Face";
function Alert(props) {
    return (
        <MuiAlert
            // style={{ zIndex: "10" }}
            elevation={6}
            variant="filled"
            {...props}
        />
    );
}
const useStyles = makeStyles((theme) => ({
    bg: {
        backgroundColor: theme.palette.background.paper,
    },
    avatar: {
        backgroundColor: theme.palette.secondary.main,
        height: "3.2rem",
        width: "3.2rem",
    },
    card: {
        // background: 'white',
        // '&:hover': {
        //   background: 'lightgrey',
        //   color: ''
        // },

        // display: 'inline-block',
        // width: '10rem',
        // margin: '1rem'
        // margin: 'auto'
        flexWrap: "wrap",
        // border: "0.1rem solid #4285F4",
        borderRadius: "14px",
        // borderRradius: '1rem'
    },
    post: {
        color: "#c7c7c7",
        fontSize: "1rem",
    },
    snackbar: {
        bottom: 80,
        zIndex: "6",
    },
    resize: {
        fontSize: 12,
    },
    underline: {
        "&&&:before": {
            borderBottom: "none",
        },
        // "&&:after": {
        //     borderBottom: "none",
        // },
    },
}));

function PostItem(props) {
    const {
        post,
        auth,
        // AddLike,
        // removeLike,
        // SavePost,
        // UnSavePost,
        addCommentNew,
    } = props;
    const [FormData, setFormData] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {
            text: "",

            errors: {},
        }
    );

    // const handleChange = (e) => {
    //     const name = e.target.name;
    //     const newValue = e.target.value;
    //     setFormData({ [name]: newValue });
    // };
    // const postId = post._id;
    // const pushKaro = () => {
    //     props.history.push(`/comment/${postId}`);
    // };
    // const handleClick = () => {
    //     const { user } = auth;

    //     const newComment = {
    //         text: FormData.text,
    //         name: user.name,
    //         avatar: user.avatar,
    //         verified: auth.verified,
    //         user: auth.user.id,
    //     };
    //     // console.log(newComment);
    //     // console.log(postId);

    //     const pcomments = post.comments;
    //     pcomments.push(newComment);

    //     // console.log(stringy);

    //     addCommentNew(postId, newComment, pushKaro);

    //     setFormData({ text: "" });
    // };
    const [success, setsuccess] = useState(false);
    const [showsub, setshowsub] = useState(false);
    const handleClose = (event, reason) => {
        setsuccess(false);
    };

    useEffect(() => {
        if (FormData.text.length > 0 && FormData.text.trim()) {
            setshowsub(true);
        } else {
            setshowsub(false);
        }
    }, [FormData.text]);
    const classes = useStyles();

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    const executeOnClick = () => {};

    //   var randomColor = Math.floor(Math.random() * 16777215).toString(16);

    const [expanded, setExpanded] = React.useState(false);
    let ele = document.getElementsByClassName("MoreButtonMain");
    let sav;
    //   console.log(success);
    // let savlength;
    // if (post.savedBy.length > 0) {
    //     savlength = post.savedBy.length;
    // }
    sav = (
        // <Badge color="primary" max={99} badgeContent={savlength}>
        <BookmarkBorderIcon
            color="secondary"
            // style={{ color: "#e2f5f6" }}
            onClick={() => {
                // SavePost(post._id);
            }}
        />
        // </Badge>
    );
    // {
    //     post.savedBy.map(function (obj) {
    //         if (obj["user"] == auth.user.id) {
    //             sav = (
    //                 // <Badge color="primary" max={99} badgeContent={savlength}>
    //                 <BookmarkIcon
    //                     // style={{ color: "#e2f5f6" }}
    //                     color="secondary"
    //                     onClick={() => {
    //                         // UnSavePost(post._id);
    //                     }}
    //                 />
    //                 // </Badge>
    //             );
    //         }
    //     });
    // }
    // console.log(post.savedBy);
    let commentlength;
    // if (post.comments.length > 0) {
    //     commentlength = post.comments.length;
    // }
    let likeslength;
    // if (post.likes.length > 0) {
    //     likeslength = post.likes.length;
    // }

    let btn;
    btn = (
        <IconButton
            // key={obj.user}
            size="small"
            color="secondary"
            style={{ marginRight: "0.4rem" }}
            onClick={() => {
                // AddLike(post._id);
            }}
        >
            {/* <Badge color="primary" max={99} badgeContent={likeslength}> */}
            <FavoriteBorderIcon />
            {/* </Badge> */}
        </IconButton>
    );
    const bind = useDoubleTap((event) => {
        // Your action here
        // AddLike(post._id);
    });
    let cmnt;
    cmnt = (
        <IconButton
            // key={obj.user}
            size="small"
            onClick={() => {
                handleExpandClick();
                // pushKaro();
            }}
        >
            {/* <Badge color="primary" max={99} badgeContent={commentlength}> */}
            <QuestionAnswerRoundedIcon
                style={
                    {
                        // color: "#e2f5f6",
                        // fontSize: "1.3rem",
                    }
                }
                color="secondary"
            />
            {/* </Badge> */}
        </IconButton>
    );

    // {
    //     post.likes.map(function (obj) {
    //         if (obj["user"] == auth.user.id) {
    //             btn = (
    //                 <IconButton
    //                     key={obj._id}
    //                     size="small"
    //                     style={{ marginRight: "0.4rem" }}
    //                     onClick={() => {
    //                         // removeLike(post._id);
    //                     }}
    //                 >
    //                     {/* <Badge
    //                         color="primary"
    //                         max={99}
    //                         badgeContent={likeslength}
    //                     > */}
    //                     <FavoriteIcon style={{ color: "#ed4956" }} />
    //                     {/* </Badge> */}
    //                 </IconButton>
    //             );
    //         }
    //     });
    // }
    useEffect(() => {
        if (expanded) {
            for (let i = 0; i < ele.length; i++) {
                ele[i].style.display = "none";
            }
        }
        if (!expanded) {
            for (let i = 0; i < ele.length; i++) {
                ele[i].style.display = "block";
            }
        }
    }, [expanded]);

    return (
        <>
            {/* <div className="img">{post.text}</div> */}
            <div style={{ margin: "0.7rem" }}>
                {/* <Card elevation={3}>
          <Typography align='center' style={{ padding: '1rem' }}>
            {post.text}
          </Typography>
        </Card> */}

                <Card
                    className={classes.card}
                    variant="elevation"
                    elevation={8}
                    {...bind}
                >
                    {/* <NavLink
                        style={{ textDecoration: "none", color: "inherit" }}
                        to={`/profile/${post.user}`}
                    > */}
                    <CardHeader
                        avatar={
                            post.avatar ? (
                                <Avatar
                                    aria-label="recipe"
                                    className={classes.avatar}
                                    src={post.avatar}
                                />
                            ) : (
                                <Avatar
                                    aria-label="recipe"
                                    className={classes.avatar}
                                    src={
                                        "https://api.adorable.io/avatars/285/abott@adorable.png"
                                    }
                                />
                            )
                        }
                        // action={
                        //     <IconButton aria-label="settings">
                        //         <MoreVertIcon />
                        //     </IconButton>
                        // }
                        title={
                            <span
                                style={{
                                    fontFamily: "Roboto,sans-serif",
                                    fontSize: "1.5rem",
                                    fontWeight: "bold",
                                    width: "200px",
                                    // border: "1px solid red",
                                    display: "block",
                                    wordWrap: "break-word",
                                }}
                            >
                                {post.name}
                                &nbsp;
                                {/* {post.verified ? (
                                        <img
                                            src={VerifiedLogo}
                                            alt="Verified"
                                            height="20"
                                            width="20"
                                        />
                                    ) : null} */}
                            </span>
                        }
                        subheader={
                            <Typography
                                color="textSecondary"
                                style={{
                                    fontWeight: "300",
                                    fontSize: "0.7rem",
                                }}
                            >
                                <Moment format="Do MMMM  YYYY">
                                    {post.date}
                                </Moment>
                            </Typography>
                        }
                    />
                    {/* </NavLink> */}
                    {/* <CardMedia
                        className={classes.media}
                        image="/static/images/cards/contemplative-reptile.jpg"
                        title="ContemplativeReptile"
                    /> */}
                    <CardContent>
                        <div style={{ wordWrap: "break-word" }}>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                component="p"
                                style={{
                                    fontFamily: "Roboto,sans-serif",
                                    fontSize: "1.4rem",
                                    fontWeight: "bold",
                                    overflow: "auto",
                                    maxWidth: "21.6rem",
                                    // border: "0.5px solid"
                                }}
                            >
                                {/* {post.text} */}

                                <ShowMoreText
                                    /* Default options */
                                    lines={3}
                                    more="read more"
                                    less="read less"
                                    anchorClass={classes.post}
                                    onClick={executeOnClick}
                                    expanded={false}
                                    width={345.6}
                                >
                                    <TextField
                                        style={{
                                            marginTop: "0.3rem",
                                            // fontSize: "2rem"
                                        }}
                                        disabled
                                        multiline
                                        fullWidth
                                        color="secondary"
                                        variant="outlined"
                                        value={post.text}
                                        name="text"
                                    ></TextField>
                                </ShowMoreText>
                            </Typography>
                        </div>
                    </CardContent>

                    <CardActions disableSpacing>
                        {btn}
                        {cmnt}
                        <div
                            style={{
                                // border: "1px solid",
                                marginLeft: "-0.2rem",
                            }}
                        >
                            <CopyToClipboard
                                onCopy={() => {
                                    setsuccess(true);
                                }}
                                text={post.text + "\n" + "\n" + "~" + post.name}
                            >
                                <div>
                                    <Button
                                        variant="text"
                                        color="secondary"
                                        style={{ textTransform: "none" }}
                                        startIcon={
                                            <FileCopyOutlinedIcon
                                                style={{
                                                    // color: "#e2f5f6",
                                                    fontSize: "1.3rem",
                                                }}
                                                color="secondary"
                                            />
                                        }
                                    ></Button>
                                </div>
                            </CopyToClipboard>
                        </div>

                        {/* <Typography>
                            <NavLink
                                to={`/profile/user/list/${JSON.stringify(
                                    post.likes
                                )}`}
                                style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                    paddingLeft: "0.4rem",

                                    width: "100%",
                                }}
                            >
                                {post.likes.length} likes
                            </NavLink>
                        </Typography> */}
                        <br />
                        {/* <Typography>{post.savedBy.length}</Typography> */}
                        {/* {console.log(auth.user.id)} */}
                        {/* {post.likes.map(function(obj) {
                            if (obj["user"] == auth.user.id) {
                                return (
                                    <IconButton
                                        key={obj._id}
                                        size="small"
                                        onClick={() => {
                                            removeLike(post._id);
                                        }}
                                    >
                                        <Badge color="secondary">
                                            <FavoriteBorderIcon />
                                        </Badge>
                                    </IconButton>
                                );
                            } else {
                                return (
                                    <IconButton
                                        key={obj.user}
                                        size="small"
                                        onClick={() => {
                                            AddLike(post._id);
                                        }}
                                    >
                                        <Badge
                                            badgeContent={post.likes.length}
                                            color="secondary"
                                        >
                                            <FavoriteIcon />
                                        </Badge>
                                    </IconButton>
                                );
                            }
                        })} */}
                        {/* <IconButton
                            size="small"
                            onClick={() => {
                                AddLike(post._id);
                            }}
                        >
                            <Badge
                                badgeContent={post.likes.length}
                                color="secondary"
                            >
                                <FavoriteIcon />
                            </Badge>
                        </IconButton> */}
                        {/* <IconButton
                            size="small"
                            onClick={() => {
                                removeLike(post._id);
                            }}
                        >
                            <Badge color="secondary">
                                <FavoriteBorderIcon />
                            </Badge>
                        </IconButton> */}

                        {/* <Button
                            className="MoreButtonMain"
                            onClick={handleExpandClick}
                            aria-expanded={expanded}
                            aria-label="show more"
                            size="small"
                            color="primary"
                            variant="contained"
                            style={{
                                marginLeft: "auto",
                            }}
                        >
                            Reply
                        </Button> */}
                        <span
                            size="small"
                            // color="primary"
                            variant="text"
                            style={{
                                marginLeft: "auto",
                                marginRight: "0.5rem",
                                // border: "1px solid",
                                // paddingRight: "-0.4rem",
                            }}
                        >
                            {sav}
                        </span>
                    </CardActions>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            // console.log("lkkl ");
                            // handleClick();
                        }}
                    >
                        <Grid container style={{ marginTop: "0.9rem" }}>
                            <Grid item xs={6}>
                                <Typography
                                    align="left"
                                    style={{
                                        // paddingRight: "auto",
                                        paddingLeft: "0.7rem",
                                        // paddingTop: "2.8rem",
                                        // marginBotmatom: "0",
                                        fontWeight: "300",
                                        marginTop: "-0.2rem",
                                    }}
                                >
                                    {/* <ButtonBase> {sav} </ButtonBase> */}
                                    {/* <NavLink
                                    to={`/profile/user/list/${JSON.stringify(
                                        post.savedBy
                                    )}`}
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit",
                                        paddingLeft: "0.4rem",

                                        width: "100%",
                                    }}
                                >
                                    {post.savedBy.length} save
                                </NavLink> */}
                                </Typography>
                            </Grid>
                            {/* <Grid item xs={6}>
                            <Typography
                                align="right"
                                style={{
                                    // paddingLeft: "auto",
                                    paddingRight: "0.7rem",
                                    fontWeight: "300",
                                    fontSize: "0.8rem",
                                }}
                            >
                                <Moment format="h:mm a">{post.date}</Moment>
                            </Typography>
                        </Grid> */}
                            {/* <Grid
                            item
                            xs={6}
                            style={{
                                paddingLeft: "0.8rem",
                                paddingTop: "0.3rem",
                                // border: "1px solid",
                            }}
                        >
                            <CopyToClipboard
                                onCopy={() => {
                                    setsuccess(true);
                                }}
                                text={post.text + "\n" + "\n" + "~" + post.name}
                            >
                                <div>
                                    <Button
                                        variant="text"
                                        color="secondary"
                                        style={{ textTransform: "none" }}
                                        startIcon={
                                            <FileCopyOutlinedIcon
                                                style={{
                                                    color: "#e2f5f6",
                                                    fontSize: "1.3rem",
                                                }}
                                            />
                                        }
                                    ></Button>
                                </div>
                            </CopyToClipboard>
                        </Grid>
 */}

                            {/* idhar se */}
                            <Grid
                                item
                                xs={12}
                                style={{
                                    marginTop: "-1.7rem",
                                    paddingLeft: "0.6rem",
                                }}
                            >
                                <Typography color="textSecondary">
                                    <NavLink
                                        to={`/profile/user/list/${JSON.stringify(
                                            post.likes
                                        )}`}
                                        style={{
                                            textDecoration: "none",
                                            color: "inherit",
                                            paddingLeft: "0.4rem",
                                            width: "100%",
                                            fontWeight: "300",
                                            fontSize: "0.8rem",
                                        }}
                                    >
                                        {/* {post.likes.length} likes */}
                                    </NavLink>
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    paddingLeft: "0.6rem",
                                    marginTop: "-0.5rem",
                                }}
                            >
                                {/* <Typography color="textSecondary">
                                    <NavLink
                                        to={`/profile/user/list/${JSON.stringify(
                                            post.savedBy
                                        )}`}
                                        style={{
                                            textDecoration: "none",
                                            color: "inherit",
                                            paddingLeft: "0.4rem",
                                            fontWeight: "300",
                                            width: "100%",

                                            fontSize: "0.8rem",
                                        }}
                                    >
                                        {post.savedBy.length} save
                                    </NavLink>
                                </Typography> */}
                            </Grid>

                            {/* <Grid item xs={6}>
                            <Grid
                                container
                                justify="center"
                                alignItems="flex-start"
                                style={
                                    {
                                       
                                    }
                                }
                            >
                                <ButtonBase
                                    onClick={handleExpandClick}
                                    className="MoreButtonMain"
                                    style={
                                        {
                                          
                                        }
                                    }
                                >
                                    <Typography
                                        color="textSecondary"
                                        style={{
                                            fontFamily: "Roboto,sans-serif",
                                            
                                        }}
                                        align="left"
                                        variant="caption"
                                    >
                                        <FiberManualRecordRoundedIcon
                                            style={{
                                                fontSize: "1.6rem",
                                                
                                                color: "green",
                                            }}
                                        />
                                        <span style={{ fontSize: "0.8rem" }}>
                                            {post.comments.length}
                                        </span>
                                        <span> comments</span>
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                        </Grid>
                      */}
                            <Grid item xs={6}>
                                <ButtonBase
                                    onClick={handleExpandClick}
                                    className="MoreButtonMain"
                                    style={{ paddingLeft: "1rem" }}
                                    onClick={() => {
                                        // pushKaro();
                                    }}
                                >
                                    <Typography
                                        color="textSecondary"
                                        style={{
                                            fontWeight: "300",
                                            fontSize: "0.8rem",
                                        }}
                                    >
                                        {/* View all {commentlength} comments */}
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography
                                    color="textSecondary"
                                    align="right"
                                    style={{
                                        // paddingLeft: "auto",
                                        paddingRight: "0.7rem",
                                        fontWeight: "300",
                                        fontSize: "0.8rem",
                                    }}
                                >
                                    {/* <ReactTimeAgo date={post.date} /> */}
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid
                                    container
                                    justify="center"
                                    alignItems="center"
                                    style={{
                                        //  border: "1px solid",
                                        padding: "0.4rem",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={1}
                                        style={{
                                            // border: "1px solid",
                                            paddingLeft: "0.5rem",
                                        }}
                                    >
                                        <Avatar
                                            className={classes.avatar}
                                            style={{
                                                height: "1.2rem",
                                                width: "1.2rem",
                                            }}
                                            src={post.image1}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        xs={10}
                                        style={{ paddingLeft: "0.4rem" }}
                                    >
                                        <TextField
                                            multiline
                                            fullWidth
                                            size="small"
                                            color="secondary"
                                            // style={{ color: "red" }}
                                            // style={{ fontSize: "0.6rem" }}
                                            // InputProps={{}}
                                            // onFocus={() => {
                                            //     setshowsub(true);
                                            // }}
                                            // onBlur={() => {
                                            //     setshowsub(false);
                                            // }}
                                            // onChange={handleChange}
                                            name="text"
                                            value={FormData.text}
                                            required
                                            inputProps={{ maxLength: 150 }}
                                            InputProps={{
                                                classes: {
                                                    input: classes.resize,
                                                    underline:
                                                        classes.underline,
                                                },
                                            }}
                                            placeholder="Add a comment..."
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={1}
                                        style={
                                            {
                                                // border: "1px solid",
                                                // paddingLeft: "1.4rem",
                                            }
                                        }
                                    >
                                        {/* <IconButton>
                                        <SendRoundedIcon
                                            style={{
                                                width: "1.1rem",
                                                height: "1.1rem",
                                            }}
                                        />
                                    </IconButton> */}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            justify="center"
                                            alignItems="center"
                                            style={{
                                                paddingLeft: "2rem",
                                                paddingRight: "2rem",
                                                paddingTop: "0.9rem",
                                            }}
                                        >
                                            {showsub ? (
                                                <Button
                                                    style={{
                                                        // height: "1rem",
                                                        fontSize: "0.9rem",
                                                        textTransform: "none",
                                                    }}
                                                    // height="2%"
                                                    fullWidth
                                                    type="submit"
                                                    // onClick={() => {
                                                    //     console.log("submit");
                                                    // }}
                                                    variant="outlined"
                                                    color="secondary"
                                                    size="small"
                                                >
                                                    Submit
                                                </Button>
                                            ) : null}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid
                                container
                                justify="flex-end"
                                alignItems="center"
                            >
                                <Grid
                                    item
                                    style={{
                                        padding: "1rem",
                                        marginTop: "-0.8rem",
                                    }}
                                >
                                    <Chip
                                        color="secondary"
                                        label={post.category}
                                        icon={<CheckRoundedIcon />}
                                        size="small"
                                    />
                                </Grid>
                            </Grid>
                            <Snackbar
                                open={success}
                                // open={true}
                                autoHideDuration={4000}
                                onClose={handleClose}
                                className={classes.snackbar}
                                // TransitionComponent={TransitionUp}
                                style={{
                                    position: "static",

                                    width: "100%",
                                    marginBottom: "0.8rem",
                                }}
                            >
                                <Alert onClose={handleClose} severity="success">
                                    Copied to Clipboard
                                </Alert>
                            </Snackbar>
                        </Grid>
                    </form>
                </Card>
            </div>
        </>
    );
}

export default PostItem;
